export function focusMe(node) {
    node.focus();
    return {
        destroy() {
//noop
        }
    };
}